import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function OurPhilosophy() {
  return <section data-section-id="222536" id="data-processing-information" className="bg-background text-foreground py-24 md:py-[140px] px-6">
      <div className="max-w-[900px] mx-auto text-center flex flex-col items-center">
        <h2 className="font-default text-4xl md:text-[56px] font-bold text-primary mb-8 leading-tight tracking-tight">
          Transparenz im Umgang mit Ihren Daten
        </h2>
        
        <div className="font-default text-xl md:text-[24px] text-foreground leading-relaxed md:leading-[1.8] mb-12 flex flex-col gap-6">
          <p>
            Der Schutz Ihrer persönlichen Informationen hat bei Baumpflege Straesser höchste Priorität während unserer Zusammenarbeit.
          </p>
          <p>Ich, Fridtjof Straesser, verarbeite personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Vorgaben der DSGVO.<br /><br />Beim Aufruf dieser Website speichert der Hosting-Anbieter automatisch Server-Logdaten (IP-Adresse in anonymisierter Form, Datum/Uhrzeit, abgerufene Seite, Browser, Betriebssystem). Diese Daten dienen der technischen Sicherheit und werden nicht zu Marketingzwecken genutzt.<br /><br />Wenn Sie mich per Telefon oder E-Mail kontaktieren, werden die von Ihnen übermittelten Daten nur zur Bearbeitung der Anfrage verwendet und nicht an Dritte weitergegeben.<br /><br />Diese Website verwendet keine Cookies, keine Analyse-Tools und keine externen Tracker.<br /><br />Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch.</p>
        </div>

        <Link to="/PrivacyPage">
          
        </Link>
      </div>
    </section>;
}